/** Ensure only one flight-search overlay (airport / date) is open at a time. */
type Closer = () => void

const closers = new Set<Closer>()

export const registerFlightSearchOverlayCloser = (close: Closer) => {
  closers.add(close)
  return () => {
    closers.delete(close)
  }
}

export const closeAllFlightSearchOverlays = (except?: Closer) => {
  closers.forEach((close) => {
    if (close !== except) close()
  })
}
